import { useRetireProduct } from '@common/hooks/useRetireProduct';
import { Id } from '@common/types';
import { useState } from 'react';

interface IProps {
  onRetireSuccess: (prodId? : Id) => void;
}

export const useRetireProductModal = ({ onRetireSuccess }: IProps) => {
  const [productIdToRetire, setProductIdToRetire] = useState<Id | undefined>();
  const { retireProduct, isRetiringProduct } = useRetireProduct();

  const handleRetireProductCancel = () => setProductIdToRetire(undefined);

  const handleRetireProductConfirm = () =>
    retireProduct(
      { productId: productIdToRetire ?? '' },
      {
        onSuccess: () => {
          const id = productIdToRetire;

          setProductIdToRetire(undefined);
          onRetireSuccess(id);
        },
        onError: () => {
          onRetireSuccess(productIdToRetire);
        },
      },
    );

  const handleRetireClick = (productId: Id) => {
    setProductIdToRetire(productId);
  };

  return {
    handleRetireProductCancel,
    handleRetireProductConfirm,
    handleRetireClick,
    productIdToRetire,
    isRetiringProduct,
  };
};
